import React, { useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import helper from "../common/Helper";

const MAP_STYLES = {
    roadmap: "mapbox://styles/mapbox/streets-v11",
    satellite: "mapbox://styles/mapbox/satellite-v9",
    terrain: "mapbox://styles/mapbox/outdoors-v11",
    hybrid: "mapbox://styles/mapbox/satellite-streets-v11"
};

const MapboxRoute = ({ routeData, mapLoaded, mapType = "terrain" }) => {
    console.log(routeData.mapZoomLevel);
    
    const mapContainerRef = useRef(null);
    const mapInstanceRef = useRef(null);

    useEffect(() => {
        if (!mapLoaded || !routeData || mapInstanceRef.current) return;

        mapboxgl.accessToken = helper.mapboxAccessToken;

        const map = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: MAP_STYLES[mapType] || MAP_STYLES.roadmap,
            center: [routeData.center.lng, routeData.center.lat],
            zoom: routeData.mapZoomLevel
        });

        mapInstanceRef.current = map;

        map.addControl(new mapboxgl.NavigationControl());

        map.on("load", () => {
            // Collect all points: start → waypoints → end
            const coordinates = [
                [routeData.start.lng, routeData.start.lat],
                ...routeData.waypoints.map(wp => [wp.lng, wp.lat]),
                [routeData.end.lng, routeData.end.lat]
            ];

            // Route line
            map.addSource("route", {
                type: "geojson",
                data: {
                    type: "Feature",
                    properties: {},
                    geometry: {
                        type: "LineString",
                        coordinates: coordinates
                    }
                }
            });

            map.addLayer({
                id: "route-line",
                type: "line",
                source: "route",
                layout: {
                    "line-join": "round",
                    "line-cap": "round"
                },
                paint: {
                    "line-color": "#1E90FF",
                    "line-width": 4
                }
            });

            // Markers: start, waypoints, end
            new mapboxgl.Marker({ color: "green" })
                .setLngLat([routeData.start.lng, routeData.start.lat])
                .addTo(map);

            routeData.waypoints.forEach((wp, i) => {
                new mapboxgl.Marker({ color: "orange" })
                    .setLngLat([wp.lng, wp.lat])
                    .setPopup(new mapboxgl.Popup().setText(`Waypoint ${i + 1}`))
                    .addTo(map);
            });

            new mapboxgl.Marker({ color: "red" })
                .setLngLat([routeData.end.lng, routeData.end.lat])
                .addTo(map);

            // Fit map to route
            const bounds = coordinates.reduce(
                (bounds, coord) => bounds.extend(coord),
                new mapboxgl.LngLatBounds(coordinates[0], coordinates[0])
            );
            map.fitBounds(bounds, { padding: 50, maxZoom: 6 });
        });
    }, [mapLoaded, routeData]);

    return <div ref={mapContainerRef} style={{ width: "100%", height: "50vh" }} />;
};

export default MapboxRoute;
